import {DetailsList, IconButton} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {SelectionMode} from "@fluentui/react";
import AppContent from "../../Surfaces/AppContent";
import AuthContext from "../../Services/AuthContext";
import EditProjectAddon from "../../Panel/ProjectAddon/EditProjectAddon";
import {Icon} from "@fluentui/react";
import {CSVDownloader} from "react-papaparse";
import {MoneyField} from "../../Utilities/MoneyField";
import ScheduleProjectAddon from "../../Panel/ProjectAddon/ScheduleProjectAddon";
import { netGrossColumn, useNetGross } from "../../Utilities/NetGrossField";

function ProjectAddon(props) {
    const [user] = useContext(AuthContext);
    const netGross = useNetGross();
    const [addons, setAddons] = useState([]);
    const [venture, setVenture] = useState('');
    const [addon, setAddon] = useState('');
    const [refresh, setRefresh] = useState(0);
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/venture/${params.id}/addon/${params.addon}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setVenture(data[0].venture);
                    setAddon(data[0].addon);
                    if (data[0].id !== null) {
                        setAddons(data);
                    } else {
                        setAddons([]);
                    }
                })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, refresh, user.token]);

    const [editAddon, setEditAddon] = useState(false);
    const [scheduleAddon, setScheduleAddon] = useState(false);

    const _deleteAddon = (id) => {
        fetch(`/api/project/${params.id}/addon/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { setAddons(addons.filter((item) => item.id !== id)) })
            .catch(err => { console.log(err) })
    }

    const _scheduleAddon = (item) => {
        return (<span>{item.schedule}
            <IconButton iconProps={ {iconName: 'calendar' }} title='Planuj' onClick={() => setScheduleAddon(item.id)}/>
        </span>)
    }

    const _doneAddon = (item) => {
        let done = (<IconButton iconProps={ {iconName: 'CheckMark' }} title='Wykonaj' onClick={() => progress(item.id, 'done')}/>);
        if (item.done !== null) {
            done = (<IconButton iconProps={ {iconName: 'History' }} title='Cofnij' onClick={() => progress(item.id, 'revert')}/>);
        }
        return (<span>{item.done}
            {done}
        </span>)
    }

    const progress = (id, action) => {
        async function processTask() {
            await fetch(`/api/addon/${id}/${action}`, {
                method: 'PUT',
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setRefresh(refresh + 1)
                })
                .catch(err => {
                    console.log(err)
                })
        }
        processTask();
    }
    const [columns, setColumns] = useState([]);
    useEffect(() => {
        setColumns([
            {
                key: 'project',
                name: 'Projekt',
                ariaLabel: 'Projekt',
                fieldName: 'project',
                minWidth: 160,
                isRowHeader: true,
                isResizable: false
            },
            {
                key: 'internal',
                name: 'Wewnętrzny',
                ariaLabel: 'Dodatek wewnętrzny',
                fieldName: 'internal',
                minWidth: 40,
                maxWidth: 40,
                isResizable: true,
                onRender: (item) => ( item.internal ? <Icon iconName={'CheckMark'} title='Tak'/> : '')
            },
            {
                key: 'schedule',
                name: 'Plan',
                ariaLabel: 'Plan Wykonania',
                fieldName: 'schedule',
                minWidth: 120,
                isResizable: true,
                onRender: _scheduleAddon
            },
            {
                key: 'done',
                name: 'Wykonano',
                ariaLabel: 'Wykonano',
                fieldName: 'done',
                minWidth: 120,
                isResizable: true,
                onRender: _doneAddon
            },
            {
                key: 'deadline',
                name: 'Termin',
                ariaLabel: 'Termin Transzy',
                fieldName: 'deadline',
                minWidth: 120,
                isResizable: true,
                onRender: (item) => ( item.deadline === null ? 'W umowie' : item.deadline)
            },
            {
                minWidth: 120,
                ...netGrossColumn('', 'price', 'Cena ')
            },
            {
                minWidth: 120,
                ...netGrossColumn('base_', 'price', 'Baza ')
            },
            {
                key: 'quantity',
                name: 'Ilość',
                ariaLabel: 'Ilość dodatku',
                fieldName: 'quantity',
                minWidth: 120,
                isResizable: true,
            },
            {
                minWidth: 120,
                ...netGrossColumn('', 'total', 'Wartość ')
            },
            {
                key: 'delete',
                name: 'Akcje',
                ariaLabel: 'Akcje',
                fieldName: 'delete',
                minWidth: 80,
                isRowHeader: true,
                isResizable: true,
                onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditAddon(item)}/>
                <IconButton iconProps={ {iconName: 'trash' }} title='Usuń' onClick={() => _deleteAddon(item.id)}/>
            </span>)
            }
        ]);
    }, [netGross]);

    return (
        <AppContent title={`${addon}`} backTo={`/venture/${params.id}/addon`}>
            <DetailsList items={addons} columns={columns} selectionMode={SelectionMode.none}/>
            <CSVDownloader data={addons} filename={`dodatki_${venture}_${addon}`} bom={true} config={{delimiter: ';'}}><IconButton iconProps={ {iconName: 'ExcelDocument' }} title='Export CSV'/></CSVDownloader>
            <EditProjectAddon edit={editAddon} dismissPanel={() => setEditAddon(false)} onSuccess={() => setRefresh(refresh + 1)}/>
            <ScheduleProjectAddon add={scheduleAddon} dismissPanel={() => setScheduleAddon(false)} onSuccess={() => setRefresh(refresh + 1)}/>
        </AppContent>
    );
}
export default ProjectAddon;